import { postWithAuth } from '../common'

export const isDemoOrg = orgId => String(orgId || '').startsWith('demo:')

export function clearClientHubDemoData() {
    // Clear only this feature's retired demo records, never real client data.
    try {
        Object.keys(localStorage)
            .filter(key => key.startsWith('managd-client-hub-demo-v1:'))
            .forEach(key => localStorage.removeItem(key))
    } catch {
        // Browser storage may be disabled; there is no live-data fallback.
    }
}

export async function hubRequest(endpoint, body, options) {
    if (isDemoOrg(body.orgId)) throw new Error('Demo contacts have been removed. Refresh Client Hub to continue.')
    return options ? postWithAuth(endpoint, body, options) : postWithAuth(endpoint, body)
}
